import React from "react";

const ADO_Property = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Property</h1>
      <p>This is the ADO Property page content.</p>
    </div>
  );
};

export default ADO_Property;
